












import { Component, Prop, Vue } from 'vue-property-decorator';

import DownloadMobileAppModal from '@/components/modals/DownloadMobileAppModal.vue';
import TheMemberCardIcon from '@/components/icons/TheMemberCardIcon.vue';
import CtaClickedGaEvent from '@/helpers/ga/events/CtaClickedGaEvent';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';
import { sendGaEvent } from '@/helpers/ga/gaSend';

@Component({
  components: {
    DownloadMobileAppModal,
    TheMemberCardIcon,
  },
})
export default class UseCultivistCardAction extends Vue {
  @Prop() labelClass: string;
  @Prop() event: any;
  @Prop({ default: 'data-details__action' }) wrapperClass: string;
  @Prop({ default: false, type: Boolean }) showAccessInstructions: boolean;
  @Prop({ default: false, type: Boolean }) isMobile: boolean;

  name = 'Use Cultivist Card';
  showModal = false;

  open() {
    this.showModal = true;
    this.$emit('toggle', this.showModal);

    const gaEvent = new CtaClickedGaEvent(this.name)
      .addContentType(getContentTypeFromEntityType(this.event.__typename))
      .addContentId(this.event.id)
      .addContentName(this.event.title);

    sendGaEvent(gaEvent);
  }

  close() {
    this.showModal = false;
    this.$emit('toggle', this.showModal);
  }
}
